import { searchReport } from '@/reports/searchReport';
import type { IpSearchRequestBody } from '@/reports/searchReport';

export interface IpSearchParams {
  ipAddress: string;
  'h-captcha-response'?: string;
  report_flags?: string;
}

export async function ipSearch(ipProps: IpSearchParams) {
  const { report_flags } = ipProps;

  let localReportFlags = [];

  if (report_flags && report_flags !== 'undefined') {
    try {
      localReportFlags = JSON.parse(report_flags);
    } catch (error) {
      throw new Error("Invalid ip report flag's format provided");
    }
  }
  const body: IpSearchRequestBody = {
    report_type: 'ip_fraud_report',
    meta: {
      ip_address: ipProps.ipAddress || '',
      report_flags: localReportFlags,
    },
    'h-captcha-response': ipProps['h-captcha-response'] || '',
  };

  return searchReport(body);
}
